import { render, staticRenderFns } from "./StatusBanner.vue?vue&type=template&id=1caf28e2"
import script from "./StatusBanner.vue?vue&type=script&lang=js"
export * from "./StatusBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports